import React, { FC } from 'react';
import BuyersSearch from './BuyersSearch';
import { Section } from 'src/common';
import { useTranslation } from 'react-i18next';
import BuyersEmpty from './BuyersEmpty';
import styles from './index.module.scss';

export const BuyersCat: FC = () => {
  const { t } = useTranslation();

  return (
    <Section title={t('BuyerProfiles.buyerProfilesSearch')} desc={t('BuyerProfiles.buyerProfilesSearchDesc')}>
      <BuyersSearch />
      <div className={styles.content}>
        <BuyersEmpty />
      </div>
    </Section>
  );
};

export default BuyersCat;
